import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { Calendar } from 'react-date-range';

import {
  isValidDate,
} from 'Utils/dateUtils';

import './SingleCalendar.scss';

class SingleCalendar extends Component {
  constructor(props, context) {
    super(props, context);

    const {
      singleDate,
    } = props;

    this.state = {
      singleDate: singleDate || moment.now(),
      errors: {
        singleDate: null,
      },
    };

    this.attachBindings();
  }

  componentDidMount() {
    this.props.onRef(this); // eslint-disable-line react/prop-types
  }

  componentWillUnmount() {
    this.props.onRef(undefined); // eslint-disable-line react/prop-types
  }

  handleOnSubmit(date) {
    this.props.onApply(this.props.id, date);
  }

  validateDateField(event) {
    const error = this.props.translations.validDateError;
    const keyCode = event.charCode || event.which;
    const numbersOnly = (keyCode >= 48 && keyCode <= 57) || keyCode === 47;
    return !numbersOnly ? this.displayError(event, error) : this.dateIsValid();
  }

  checkDate(event) {
    const error = this.props.translations.validDateError;
    const d = event.target.value;
    const isValid = (isValidDate(d, this.props.dateFormat));
    return !isValid ? this.displayError(event, error) : this.dateIsValid();
  }

  displayError(event, error) {
    const errors = { ...this.state.errors };
    errors[event.target.id] = error;
    this.setState({
      errors,
    });
    return false;
  }

  dateIsValid() {
    const errors = {
      start: null,
    };

    this.setState({ errors });
  }


  attachBindings() {
    this.handleOnSubmit = this.handleOnSubmit.bind(this);
    this.validateDateField = this.validateDateField.bind(this);
    this.checkDate = this.checkDate.bind(this);
    this.displayError = this.displayError.bind(this);
  }

  render() {
    const { dateFormat, id, minDate, maxDate } = this.props;
    const { singleDate } = this.state;

    return (
      <div className="single-calendar" id={id}>
        <div className="single-calendar__top">
          <Calendar
            date={isValidDate(singleDate, dateFormat) ? moment(singleDate).format(dateFormat) : moment(singleDate).format(dateFormat)}
            format={dateFormat}
            minDate={new Date(minDate)}
            maxDate={maxDate !== '' ? new Date(maxDate) : new Date(new Date().setFullYear(new Date().getFullYear() + 1))}
            onChange={this.handleOnSubmit}
          />
        </div>
      </div>
    );
  }
}

SingleCalendar.propTypes = {
  dateFormat: PropTypes.string.isRequired,
  id: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
  ]).isRequired,
  onApply: PropTypes.func.isRequired,
  onRef: PropTypes.func,
  minDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ]),
  maxDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ]),
  singleDate: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object,
  ]),
  translations: PropTypes.object,
};

SingleCalendar.defaultProps = {
  onRef: () => { },
  minDate: '',
  maxDate : '',
  singleDate: '',
  translations: {
    validDateError: 'Please enter a valid date.',
  },
};

export default SingleCalendar;
